module.exports = __webpack_public_path__ + "resources/c3d66210a8505c528f45bad5fc394e62.png";